<template>
  <v-btn
    icon
    text
    x-small
    class="ma-0 pa-1 mr-1"
    :color="mode === 'light' ? 'white' : '#585858'"
    @click="click"
  >
    <v-icon size="15">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "WindowHeaderButton",

  props: {
    /**
     * Receives the type of action that the button will have, it can only be close or minimize
     */
    action: {
      type: String,
      default: "close",
      validator(value) {
        return ["close", "minimize", "newtab"].indexOf(value) !== -1;
      }
    },

    /**
     * Receives the mode/style that the button will have, it can only be light or dark
     */
    mode: {
      type: String,
      default: "light",
      validator(value) {
        return ["dark", "light"].indexOf(value) !== -1;
      }
    }
  },

  computed: {
    /**
     * Determines the icon according to the action it receives
     * @returns {string}
     */
    icon() {
      switch (this.action) {
        case "minimize":
          return "remove_circle";
        case "newtab":
          return "open_in_new"
        default:
          return "cancel";
      }
    }
  },

  methods: {
    /**
     * Clicking the button emits an action to the parent component
     */
    click() {
      this.$emit("onClick");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_Atoms/WindowHeaderButton.vue